package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.models.LanguageState
import io.horion.cv.styles.ActivityFullWidthFieldStyle
import io.horion.cv.styles.ActivityHalfWidthFieldStyle
import io.horion.cv.styles.DropdownStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.viewModel.CvViewModel
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cursor
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.paddingLeft
import org.jetbrains.compose.web.css.paddingRight
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.Select
import org.jetbrains.compose.web.dom.Text

@Composable
fun LanguageForm(
    index: Int,
    state: LanguageState,
    cvViewModel: CvViewModel,
    onDelete: () -> Unit,
    onComplete: () -> Unit
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(25.px),
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .displayUntil(Breakpoint.MD)
        ) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(16.px)
            ) {
                Column(
                    modifier = ActivityFullWidthFieldStyle.toModifier(),
                    horizontalAlignment = Alignment.Start
                ) {
                    SpanText(
                        text = "Langue",
                        modifier = Modifier
                            .color(if (isDark) Colors.White else Colors.Primary)
                            .fontSize(14.px)
                            .fontFamily(INTER)
                            .fontWeight(FontWeight.Light)
                            .margin(bottom = 8.px)
                    )
                    LanguageNameDropdown(
                        selectedLangue = state.langue,
                        onLangueChange = {
                            state.langue = it
                            cvViewModel.updateLanguage(index, name = it)
                        },
                        modifier = Modifier.fillMaxWidth(),
                        isDark = isDark
                    )
                }

                Column(
                    modifier = ActivityFullWidthFieldStyle.toModifier(),
                    horizontalAlignment = Alignment.Start
                ) {
                    SpanText(
                        text = "Niveau",
                        modifier = Modifier
                            .color(if (isDark) Colors.White else Colors.Primary)
                            .fontSize(14.px)
                            .fontFamily(INTER)
                            .fontWeight(FontWeight.Light)
                            .margin(bottom = 8.px)
                    )
                    LangueDropdown(
                        selectedNiveau = state.niveau,
                        onNiveauChange = {
                            state.niveau = it
                            cvViewModel.updateLanguage(index, level = it)
                        },
                        modifier = Modifier.fillMaxWidth(),
                        isDark = isDark
                    )
                }
            }
        }

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .displayIfAtLeast(Breakpoint.MD)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(25.px)
            ) {
                Column(
                    modifier = ActivityHalfWidthFieldStyle.toModifier(),
                    horizontalAlignment = Alignment.Start
                ) {
                    SpanText(
                        text = "Langue",
                        modifier = Modifier
                            .color(if (isDark) Colors.White else Colors.Primary)
                            .fontSize(16.px)
                            .fontFamily(INTER)
                            .fontWeight(FontWeight.Light)
                            .margin(bottom = 8.px)
                    )
                    LanguageNameDropdown(
                        selectedLangue = state.langue,
                        onLangueChange = {
                            state.langue = it
                            cvViewModel.updateLanguage(index, name = it)
                        },
                        modifier = Modifier.fillMaxWidth(),
                        isDark = isDark
                    )
                }

                Column(
                    modifier = ActivityHalfWidthFieldStyle.toModifier(),
                    horizontalAlignment = Alignment.Start
                ) {
                    SpanText(
                        text = "Niveau",
                        modifier = Modifier
                            .color(if (isDark) Colors.White else Colors.Primary)
                            .fontSize(16.px)
                            .fontFamily(INTER)
                            .fontWeight(FontWeight.Light)
                            .margin(bottom = 8.px)
                    )
                    LangueDropdown(
                        selectedNiveau = state.niveau,
                        onNiveauChange = {
                            state.niveau = it
                            cvViewModel.updateLanguage(index, level = it)
                        },
                        modifier = Modifier.fillMaxWidth(),
                        isDark = isDark
                    )
                }
            }
        }

        FormActionButtons(
            onDelete = onDelete,
            onComplete = onComplete
        )
    }
}

@Composable
fun LangueDropdown(
    selectedNiveau: String,
    onNiveauChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    isDark: Boolean = false,
) {
    val niveaux = listOf(
        "BEGINNER" to "Débutant",
        "INTERMEDIATE" to "Intermédiaire",
        "GOOD" to "Bien",
        "VERY_GOOD" to "Très bien",
        "EXCELLENT" to "Courant"
    )
    val grades = listOf(
        "A1" to "A1",
        "A2" to "A2",
        "B1" to "B1",
        "B2" to "B2",
        "C1" to "C1",
        "C2" to "C2"
    )

    val textColor = if (isDark) Colors.Primary else (if (selectedNiveau.isEmpty()) Colors.White.copyf(alpha = 0.5f) else Colors.White)
    val optionTextColor = if (isDark) Colors.Primary else Colors.White

    Select(
        attrs = DropdownStyle.toModifier()
            .toAttrs {
                style {
                    backgroundColor(Colors.input)
                    color(textColor)
                    border(0.px)
                    borderRadius(5.px)
                    paddingLeft(10.px)
                    paddingRight(20.px)
                    fontSize(16.px)
                    cursor("pointer")
                    property("transition", "border-color 200ms")
                    property("outline", "none")
                }
                onChange { event ->
                    onNiveauChange(event.target.value)
                }
            }
    ) {
        Option(
            value = "",
            attrs = {
                if (selectedNiveau.isEmpty()) selected()
                style {
                    color(if (isDark) Colors.White else Colors.Primary)
                }
            }
        ) {
            Text("Choisissez")
        }

        niveaux.forEach { (enumName, label) ->
            Option(
                value = enumName,
                attrs = {
                    if (enumName == selectedNiveau) {
                        selected()
                    }
                    style {
                        backgroundColor(Colors.input)
                        color(optionTextColor)
                    }
                }
            ) {
                Text(label)
            }
        }
        Option(
            value = "__separator__",
            attrs = {
                disabled()
                style {
                    backgroundColor(Colors.Primary)
                    padding(0.px)
                    margin(0.px)
                    property("border", "none")
                    property("height", "1px")
                    property("min-height", "1px")
                    property("max-height", "1px")
                    property("line-height", "1px")
                    color(Colors.Primary)
                    property("pointer-events", "none")
                }
            }
        ) {
            Text("─".repeat(15))
        }

        grades.forEach { (enumName, label) ->
            Option(
                value = enumName,
                attrs = {
                    if (enumName == selectedNiveau) {
                        selected()
                    }
                    style {
                        backgroundColor(Colors.input)
                        color(optionTextColor)
                    }
                }
            ) {
                Text(label)
            }
        }
    }
}

@Composable
fun LanguageNameDropdown(
    selectedLangue: String,
    onLangueChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    isDark: Boolean = false,
) {
    val options = listOf(
        "FRENCH" to "Français",
        "ENGLISH" to "Anglais",
        "GERMAN" to "Allemand",
        "SPANISH" to "Espagnol",
        "ARABIC" to "Arabe",
        "CHINESE" to "Chinois",
        "RUSSIAN" to "Russe"
    )

    val textColor = if (isDark) Colors.Primary else (if (selectedLangue.isEmpty()) Colors.White.copyf(alpha = 0.5f) else Colors.White)
    val optionTextColor = if (isDark) Colors.Primary else Colors.White

    Select(
        attrs = DropdownStyle.toModifier()
            .toAttrs {
                style {
                    backgroundColor(Colors.input)
                    color(textColor)
                    border(0.px)
                    borderRadius(5.px)
                    paddingLeft(10.px)
                    paddingRight(20.px)
                    fontSize(16.px)
                    cursor("pointer")
                    property("outline", "none")
                }
                onChange { event ->
                    onLangueChange(event.target.value)
                }
            }
    ) {
        Option(
            value = "",
            attrs = {
                if (selectedLangue.isEmpty()) selected()
                style {
                    color(if (isDark) Colors.White else Colors.Primary)
                }
            }
        ) {
            Text("Choisissez une langue")
        }

        options.forEach { (key, label) ->
            Option(
                value = key,
                attrs = {
                    if (key == selectedLangue) selected()
                    style {
                        backgroundColor(Colors.input)
                        color(optionTextColor)
                    }
                }
            ) {
                Text(label)
            }
        }
    }
}